const Message = ({ icon, title, subtitle, children = null, extraClassName = null }) => {
    return (
        <div className={`Message--Primary ${extraClassName && extraClassName}`}>
            {icon && (
                <p className='Message--Primary__Icon'><i className={`${icon} Message--Primary__Icon`}></i></p>
            )}

            {title && title !== '' && (
                <p className='Message--Primary__Title'>{title}</p>
            )}
            
            {subtitle && subtitle !== '' && (
                <p className='Message--Primary__Text'>{subtitle}</p>
            )}

            {children}
        </div>
    )
}

export { Message };